import { environment as env } from '../../environments/environment';
import {AdToolsFilterOption, AdToolsList} from './tool';

export class ToolFixtures {

  public static getAffiliateAdToolsList(): AdToolsList {
    let list = {
      '03139623-83b6-454c-b420-ee368f0ee957': {
        displayName: 'Custom Link Builder',
        displaySubtitle: 'Build tracking links to any page on a merchant\'s website in seconds.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Custom_Link_Builder.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'CustomLinkBuilderAffiliate'} },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'CustomLinkBuilderAffiliate'} }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '816fc9c7-9d77-4efa-8eef-74555099e193': {
        displayName: 'Discounts',
        displaySubtitle: 'Merchant provided discounts and coupon codes.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/discount_icon.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'Discount' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Get Discounts',
            buttonClassList: ['green', 'discounts'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'Discount' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '51d358d9-fc50-44ae-be5b-1c7c96a5e6f4': {
        displayName: 'Ad Management',
        displaySubtitle: 'Merchant provided banner and text ads.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Merchant_Ads.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'MerchantAds' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Get Ads',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'MerchantAds' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '7960670e-c17e-4fb9-b00f-1ec80671752d': {
        displayName: 'Easy Link',
        displaySubtitle: `Create tracking links directly from a merchant's website.`,
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Easy_Link.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'EasyLink' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Download',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'EasyLink' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      'cc2ed069-893d-41b4-a8fd-099c11e6782f': {
        displayName: 'Product Link',
        displaySubtitle: 'Create tracking links to merchant product pages.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Product_Link.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'ProductLink' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'ProductLink' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true,
          product_based: true
        },
      },
      'c80254b4-8972-4959-b402-96acf1527ac4': {
        displayName: 'QR Code Builder',
        displaySubtitle: 'Build a QR Code to any page on a merchant\'s website.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/qr_code_icon.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'QRCode' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'QRCode' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '3a4ed0d9-4f28-47fd-96c3-ccf0a94735be': {
        displayName: 'Affiliate Link Encoder',
        displaySubtitle: ' Automatically encode keywords and direct links into affiliate tracking links',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Affiliate_Link_Encoder.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'AffiliateLinkEncoder' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey:  'AffiliateLinkEncoder' } }
          },
          {
            buttonText: 'Edit',
            buttonClassList: ['blue'],
            buttonClickResponse: { action: 'route', context: { routeKey:  'AffiliateLinkEncoderEdit' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '4ecbec0b-68e7-4784-9817-27ef001b98bb': {
        displayName: 'Datafeed Manager',
        displaySubtitle: 'Customizable datafeeds. Updated daily.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Datafeed_Manager.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'DatafeedManager' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'DatafeedManager' } }
          },
          {
            buttonText: 'Edit',
            buttonClassList: ['blue'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'DatafeedManagerEdit' } }
          }
        ],
        filterTags: {
          all: true,
          avantlink: true,
          product_based: true
        },
      },
      // '617220ad-5361-4837-b717-26a85cbeb3ee': {
      //   displayName: 'Immerxon Video',
      //   displaySubtitle: 'Record a video and tag products used in the video with affiliate tracking links.',
      //   displayDescription: 'Third Party Tool',
      //   iconUrl: '/assets/images/ad-tools-icons/Immerxon.svg',
      //   iconClickResponse: { action: 'route', context: { routeKey: 'ImmerxonVideo' } },
      //   toggleSwitch: {
      //     state: false,
      //   },
      //   buttons: [
      //     {
      //       buttonText: 'Create',
      //       buttonClassList: ['green'],
      //       buttonClickResponse:  { action: 'route', context: { routeKey:  'ImmerxonVideo' } }
      //     }
      //   ],
      //   filterTags: {
      //     all: true,
      //     third_party: true
      //   },
      // },
      'ba0f85e4-b444-4ddc-a206-af2befa6918a': {
        displayName: 'Product Ad Widget',
        displaySubtitle: 'Dynamic and customizable widget for displaying products.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Product_Ad_Widget.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'ProductAdWidget' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'ProductAdWidget' } }
          },
          {
            buttonText: 'Edit',
            buttonClassList: ['blue'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'ProductAdWidgetEdit' } }
          }
        ],
        filterTags: {
          all: true,
          avantlink: true,
          product_based: true
        },
      },
      'f14e6e90-8427-4bf8-bf39-7a3a76cbe6b3': {
        displayName: 'AvantLink API',
        displaySubtitle: 'Advanced data input and retrieval functionality for affiliates.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/API.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'APIRequestBuilder' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'APIRequestBuilder' } }
          }
        ],
        filterTags: {
          all: true,
          avantlink: true,
          product_based: true
        },
      },
      '4ba518b3-4348-41a0-b15e-c91483412cf3': {
        displayName: 'SnapLinker',
        displaySubtitle: 'Visit a merchant webpage and simply press a button to create a tracking link.',
        displayDescription: 'Third Party Tool',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Snaplinker.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'SnapLinker' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'SnapLinker' } }
          }
        ],
        filterTags: {
          all: true,
          featured: false,
          third_party: true
        },
      },
      '8bd62142-d806-4dd6-bdd2-48775be316e9': {
        displayName: 'SnapVisi',
        displaySubtitle: 'Merchant provided banner and text ads.',
        displayDescription: 'Third Party Tool',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/SnapVisi.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'SnapVisi' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'SnapVisi' } }
          }
        ],
        filterTags: {
          all: true,
          third_party: true
        },
      },
      '4a06dd4e-ae4a-4ca1-a221-fb0c28d040aa': {
        displayName: 'SnapSearcher',
        displaySubtitle: 'Add a product search to your website with a simple copy/paste integration.',
        displayDescription: 'Third Party Tool',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/SnapSearcher.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'SnapSearcher' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'SnapSearcher' } }
          }
        ],
        filterTags: {
          all: true,
          third_party: true
        },
      },
      'c10a3434-d683-4e4d-a4de-07109cad19c8': {
        displayName: 'SnapDealist',
        displaySubtitle: ' Quickly add discounted products by scanning your website.',
        displayDescription: 'Third Party Tool',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/SnapDealist.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'SnapDealist' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'SnapDealist' } }
          }
        ],
        filterTags: {
          all: true,
          third_party: true
        },
      },
      'f72303fa-3895-49dd-9e2f-42acd9557470': {
        displayName: 'Product Content Widget',
        displaySubtitle: 'Automated product information and price comparisons between merchants.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Product_Content_Widget.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'ProductContentWidget' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'ProductContentWidget' } }
          },
          {
            buttonText: 'Edit',
            buttonClassList: ['blue'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'ProductContentWidgetEdit' } }
          }
        ],
        filterTags: {
          all: true,
          avantlink: true,
          product_based: true
        },
      },
      '9587dc69-df3e-4bef-bced-000c633b8558': {
        displayName: 'Contextual Ad Tool',
        displaySubtitle: 'Displays relevant ads based on the content of the webpage.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Contextual_Ad_Tool.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'ContextualAdTool' } },
        toggleSwitch: {
          state: false,
        },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['green'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'ContextualAdTool' } }
          }
        ],
        filterTags: {
          all: true,
          avantlink: true
        },
      },
    };
    return list;
  }

  public static getMerchantAdToolsList(): AdToolsList {
    let list = {
      '51d358d9-fc50-44ae-be5b-1c7c96a5e6f4': {
        displayName: 'Ad Management',
        displaySubtitle: 'Manage banner and text ad creative.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Merchant_Ads.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'MerchantAds' } },
        buttons: [
          {
            buttonText: 'Manage',
            buttonClassList: ['blue'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'MerchantAds' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '816fc9c7-9d77-4efa-8eef-74555099e193': {
        displayName: 'Discounts',
        displaySubtitle: 'Manage the discounts and coupon codes that are available to your affiliate partners.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/discount_icon.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'Discount' } },
        buttons: [
          {
            buttonText: 'Manage',
            buttonClassList: ['blue'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'Discount' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '03139623-83b6-454c-b420-ee368f0ee957': {
        displayName: 'Custom Link Builder',
        displaySubtitle: 'Create tracking links for your affiliate partners.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Custom_Link_Builder.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'CustomLinkBuilderMerchant'} },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['blue'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'CustomLinkBuilderMerchant'} }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      'c80254b4-8972-4959-b402-96acf1527ac4': {
        displayName: 'QR Code Builder',
        displaySubtitle: 'Create a QR Code for your affiliate partners.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/qr_code_icon.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'QRCode' } },
        buttons: [
          {
            buttonText: 'Create',
            buttonClassList: ['blue'],
            buttonClickResponse: { action: 'route', context: { routeKey: 'QRCode' } }
          }
        ],
        filterTags: {
          all: true,
          featured: true,
          avantlink: true
        },
      },
      '4524da22c-7c52-4b29-a221-28fb3ff294c8': {
        displayName: 'Datafeed Administration',
        displaySubtitle: 'Review datafeeds and create specialized subsets.',
        iconUrl: env.dashboardUrl + '/assets/images/ad-tools-icons/Datafeed_Manager.svg',
        iconClickResponse: { action: 'route', context: { routeKey: 'DatafeedAdministration' } },
        buttons: [
          {
            buttonText: 'Manage',
            buttonClassList: ['blue'],
            buttonClickResponse:  { action: 'route', context: { routeKey:  'DatafeedAdministration' } }
          }
        ],
        filterTags: {
          all: true,
          avantlink: true,
          product_based: true
        },
      },
    };
    return list;
  }

  public static getAdToolsFilterOptions(): Array<AdToolsFilterOption> {
    return [
      {
        displayName: 'All',
        value: 'all'
      },
      {
        displayName: 'Featured',
        value: 'featured'
      },
      {
        displayName: 'AvantLink',
        value: 'avantlink'
      },
      {
        displayName: 'Product Based',
        value: 'product_based'
      },
      {
        displayName: 'Third Party',
        value: 'third_party'
      },
      {
        displayName: 'My Favorites',
        value: 'favorite'
      }
    ];
  }
}
